'use client';

import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { LanguageCourseInfo } from '@/components/ui/data-display/language-course-info/LanguageCourseInfo';
import { useContext } from 'react';

export const LanguageCourseInfoBlock = ({ data, ...props }) => {
  const { st } = useContext(StaticTextContext);
  return (
    <LanguageCourseInfo
      data={data}
      texts={{
        selectedCourse: st('forms.enrollment.selected_course'),
        available: st('forms.enrollment.available'),
        notAvailable: st('forms.enrollment.not_available'),
        intro: st('forms.enrollment.intro'),
        introNotAvailable: st('forms.enrollment.intro_not_available'),
      }}
      {...props}
    />
  );
};
